import { useState, useEffect } from "react";
import { Box, Button, FormControl, FormControlLabel, FormLabel, MenuItem, Switch, TextField, Typography, CircularProgress, Dialog, Tooltip, Grid, styled } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CodeIcon from "@mui/icons-material/Code";
import FormatTextdirectionLToRIcon from "@mui/icons-material/FormatTextdirectionLToR";
import { Schedule as ScheduleIcon, LinkOff as LinkOffIcon, Link as LinkIcon } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { useMutation, useLazyQuery } from "@apollo/client";
// eslint-disable-next-line import/no-named-as-default-member
import { useNavigate } from "react-router-dom";
import BackButton from "../../BackButton/BackButton";
import ContentGeneratePopup from "./ContentGeneratePopup";
import { ContentEditHeaderStyle, ImportMenuWrapper } from "./css";
import ImportRawHtmlPopup from "./ImportRawHtmlPopup";
import {
  generateParagraph,
  analyseAndUpdateBlog,
  UPDATE_CONTENT_QUERY_STATUS,
  UPDATE_META_DESCRIPTION,
  GENERATE_META_DESCRIPTION_BY_QUERY_ID,
  SCHEDULE_POST,
} from "../../../gql/mutations/scrapy";
import { GetProjectByUserId } from "../../../hooks/userWebsiteData";
import { PUBLISH_BLOG_SHOPIFY, PUBLISH_BLOG_WORDPRESS } from "../../../gql/mutations/userWebSiteVisit";
import { usePopup } from "../../../context/commonPop";
import { GET_WORDPRESS_CATEGORIES } from "../../../gql/queries/scrapy";
import { convertToBase64 } from "../../../utils/myUtills";
import ImageCropper from "../../common/ImageCropper";
import FeaturedImageEditor from "../../common/FeaturedImageEditor";

const CustomBgTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.mode === "dark" ? "#afb2b8" : "#EAEBED",
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    padding: "0px",

    "& textarea": {
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "1.5",
      color: theme.palette.mode === "dark" ? "#2A3547" : theme.palette.text.default,
    },
  },
}));

function ContentEditHeader({
  queryId,
  updateQueryTitle,
  queryName,
  title,
  generateTitleHandler,
  setTitle,
  contentQuery,
  refetchContent,
  content,
  setContent,
  isDirty,
  setIsDirty,
  loadingTitle,
  setLoadingTitle,
  featuredImageUrl: externalFeaturedImageUrl,
}) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [openImportRawHtml, setOpenImportRawHtml] = useState(false);
  const handleCloseImportRawHtml = () => setOpenImportRawHtml(false);
  const [anchorElImport, setAnchorElImport] = useState(null);
  const [anchorElExport, setAnchorElExport] = useState(null);
  const openImport = Boolean(anchorElImport);
  const openExport = Boolean(anchorElExport);
  const [updateBlog] = useMutation(analyseAndUpdateBlog);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [updateMetaDescription] = useMutation(UPDATE_META_DESCRIPTION);
  const { allProjectWithSessionId } = GetProjectByUserId({ RequireSessionId: 1 });
  const { handleOpen } = usePopup();
  const [updateStatus] = useMutation(UPDATE_CONTENT_QUERY_STATUS);
  const [metaDescription, setMetaDescription] = useState(contentQuery.metaDescription || "");
  const [openPublishDialog, setOpenPublishDialog] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [publishing, setPublishing] = useState(false);
  const [publishBlogShopify] = useMutation(PUBLISH_BLOG_SHOPIFY);
  const [publishBlogWordpress] = useMutation(PUBLISH_BLOG_WORDPRESS);
  const [schedulePost, { loading: scheduling }] = useMutation(SCHEDULE_POST);
  const [scheduleMode, setScheduleMode] = useState(false);
  const [scheduledAt, setScheduledAt] = useState(dayjs().add(1, "hour"));
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [useCustomImage, setUseCustomImage] = useState(false);
  const [featuredImageUrl, setFeaturedImageUrl] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [cropperOpen, setCropperOpen] = useState(false);
  const [rawImageSrc, setRawImageSrc] = useState(null);
  const [editorOpen, setEditorOpen] = useState(false);
  const [croppedForEditor, setCroppedForEditor] = useState(null);
  const [fetchCategories, { loading: categoriesLoading }] = useLazyQuery(GET_WORDPRESS_CATEGORIES, {
    fetchPolicy: "network-only",
    onCompleted: data => setCategories(data?.getWordPressCategories || []),
  });
  const connectedProjects = (allProjectWithSessionId || []).filter(p => p?.isConnected === true && p?.integrationToken && Object.keys(p.integrationToken).length > 0);
  const allProjects = allProjectWithSessionId || [];
  const [generateMetaDescription, { loading: loadingMeta }] = useLazyQuery(GENERATE_META_DESCRIPTION_BY_QUERY_ID, {
    fetchPolicy: "no-cache",
    onCompleted: data => {
      if (data?.generateMetaDescriptionByQueryId) {
        setMetaDescription(data.generateMetaDescriptionByQueryId);
        setIsDirty(true);
      }
    },
    onError: error => {
      console.error("Meta description generation failed:", error.message);
    },
  });

  const generateMetaDescriptionHandler = () => {
    if (!contentQuery?._id) return;

    generateMetaDescription({
      variables: {
        queryId: contentQuery._id,
      },
    });
  };

  useEffect(() => {
    if (refetchContent) {
      refetchContent();
    }
  }, []);

  // useEffect(() => {
  //   if (contentQuery?.metaDescription) {
  //     setMetaDescription(contentQuery.metaDescription);
  //   }
  // }, [contentQuery?.metaDescription]);

  useEffect(() => {
    if (contentQuery && !isDirty) {
      setMetaDescription(contentQuery.metaDescription || "");
    }
  }, [contentQuery]);

  const handleClickImport = event => {
    setAnchorElImport(event.currentTarget);
  };
  const handleClickExport = event => {
    setAnchorElExport(event.currentTarget);
  };
  const handleCloseImport = () => {
    setAnchorElImport(null);
  };
  const handleCloseExport = () => {
    setAnchorElExport(null);
  };
  // const handleSave = () => {
  //   if (title.trim()) {
  //     updateQueryTitle(title.trim());
  //   }
  // };
  const handleSaveContent = async () => {
    if (!title.trim() || !content.trim()) return;
    setLoading(true);

    try {
      await updateBlog({
        variables: {
          data: {
            queryId: contentQuery._id,
            title,
            html: content,
            metaDescription,
          },
        },
      });

      if (metaDescription !== contentQuery?.metaDescription) {
        await updateMetaDescription({
          variables: {
            data: {
              queryId: contentQuery._id,
              metaDescription,
            },
          },
        });
      }

      setIsDirty(false);
      // refetch updated content from backend
      if (refetchContent) {
        refetchContent();
      }
    } catch (error) {
      console.error("Error saving blog:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmSave = async () => {
    try {
      // Save content first
      await handleSaveContent();

      // Update status to Done
      await updateStatus({
        variables: {
          queryId: contentQuery._id,
          status: "Done",
        },
      });

      // Navigate to content score page
      // navigate("/content-score");
      navigate("/content-score", {
        state: { showSuccessPopup: true },
      });
    } catch (error) {
      console.error("Error while saving & updating status:", error);
    } finally {
      setOpenConfirm(false);
    }
  };

  const downloadFile = (data, fileName, type) => {
    // export helper function
    const blob = new Blob([data], { type });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(url);
  };

  const exportRawHTML = () => {
    // export raw html
    if (!content) return;

    const html = `
<h1>${title}</h1>
${content}
`;

    downloadFile(html, "blog-raw.html", "text/html");
  };

  const exportMinimalHTML = () => {
    // export minimal html
    if (!content) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    doc.querySelectorAll("style, script").forEach(el => el.remove());
    doc.querySelectorAll("*").forEach(el => {
      el.removeAttribute("style");
      el.removeAttribute("class");
      el.removeAttribute("id");
    });

    const html = `
${doc.body.innerHTML}
`;

    downloadFile(html, "blog-minimal.html", "text/html");
  };

  const exportCustomHTML = () => {
    // export custom html
    if (!content) return;

    const html = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <title>${title}</title>
</head>
<body>
  ${content}
</body>
</html>
`;

    downloadFile(html, "blog-custom.html", "text/html");
  };

  const exportFormattedText = () => {
    // export formatted text
    if (!content) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    const text = `${doc.body.innerText}`;
    downloadFile(text, "blog.txt", "text/plain");
  };

  const removeHeaderAndH1 = html => {
    if (!html) return html;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const header = doc.querySelector("header");
    if (header) {
      header.remove();
    }
    const firstH1 = doc.querySelector("h1");
    if (firstH1) {
      firstH1.remove();
    }

    return doc.body.innerHTML;
  };
  const handleScheduleBlog = async project => {
    if (!project) return;
    if (!scheduledAt || !scheduledAt.isValid() || scheduledAt.isBefore(dayjs())) {
      handleOpen(false, "Please select a future date and time");
      return;
    }
    try {
      setPublishing(true);
      const cleanContent = removeHeaderAndH1(content);
      await schedulePost({
        variables: {
          input: {
            projectId: project.id,
            title,
            body: cleanContent,
            description: metaDescription || "",
            publishAt: scheduledAt.toISOString(),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            ...(selectedCategoryId && { categoryId: selectedCategoryId }),
            ...(useCustomImage && featuredImageUrl.trim()
              ? { featuredImageUrl: featuredImageUrl.trim() }
              : externalFeaturedImageUrl
              ? { featuredImageUrl: externalFeaturedImageUrl }
              : {}),
          },
        },
      });
      handleOpen(true, "Blog scheduled successfully");
      setOpenPublishDialog(false);
      setSelectedProject(null);
      setScheduleMode(false);
      setSelectedCategoryId("");
      setCategories([]);
      setUseCustomImage(false);
      setFeaturedImageUrl("");
      setImagePreview(null);
      setCropperOpen(false);
      setRawImageSrc(null);
      setEditorOpen(false);
      setCroppedForEditor(null);
    } catch (error) {
      handleOpen(false, error.message || "Failed to schedule blog");
    } finally {
      setPublishing(false);
    }
  };

  const handlePublishBlog = async project => {
    try {
      if (!project) return;

      setPublishing(true);

      const { appType, id: projectId, website } = project;
      const cleanContent = removeHeaderAndH1(content);
      if (appType === "Shopify") {
        const { data } = await publishBlogShopify({
          variables: {
            inputdata: {
              body: cleanContent,
              description: metaDescription || "Testing Description For Blog Upload",
              projectId,
              title,
            },
          },
        });

        if (data) {
          handleOpen(true, "Blog Published Successfully");
          setOpenPublishDialog(false);
          setSelectedProject(null);
        }
      } else if (appType === "Wordpress") {
        const { data } = await publishBlogWordpress({
          variables: {
            inputdata: {
              body: cleanContent,
              description: metaDescription || "Testing Description For Blog Upload",
              projectId,
              domain: website,
              title,
              ...(selectedCategoryId && { categoryId: selectedCategoryId }),
              ...(useCustomImage && featuredImageUrl.trim()
                ? { featuredImageUrl: featuredImageUrl.trim() }
                : externalFeaturedImageUrl
                ? { featuredImageUrl: externalFeaturedImageUrl }
                : {}),
            },
          },
        });

        if (data) {
          const postLink = data?.CreateBlogForWordPress?.post?.link;
          handleOpen(true, "Blog Published Successfully", postLink);

          setOpenPublishDialog(false);
          setSelectedProject(null);
        }
      } else {
        console.error("Unsupported apptype:", appType);
        setOpenPublishDialog(false);
        setSelectedProject(null);
      }
    } catch (error) {
      console.error("Error publishing blog:", error);
    } finally {
      setPublishing(false);
    }
  };

  useEffect(() => {
    if (openPublishDialog) {
      setSelectedProject(null);
      setSelectedCategoryId("");
      setCategories([]);
      setUseCustomImage(false);
      setFeaturedImageUrl("");
      setImagePreview(null);
      setCropperOpen(false);
      setRawImageSrc(null);
      setEditorOpen(false);
      setCroppedForEditor(null);
    }
  }, [openPublishDialog]);
  return (
    <ContentEditHeaderStyle>
      <Box className="ContentWrapper">
        <Box>
          <Typography component="h2">{queryName}</Typography>
        </Box>
        <Box className="BtnWrapper">
          {content && content.trim() && (
            <>
              <Button onClick={() => setOpen(!open)} sx={{ minWidth: "181px" }}>
                <AutoFixHighIcon /> Content Builder
              </Button>
              <Tooltip title="Save Changes" placement="top" arrow>
                <span>
                  <Button sx={{ minWidth: "130px" }} onClick={handleSaveContent} variant="contained" disabled={loading || !isDirty}>
                    {loading ? <CircularProgress size={25} color="inherit" /> : "Save"}
                  </Button>
                </span>
              </Tooltip>
              <Box>
                <Button disableElevation onClick={handleClickImport}>
                  Import
                </Button>
                <ImportMenuWrapper anchorEl={anchorElImport} open={openImport} onClose={handleCloseImport}>
                  <MenuItem
                    onClick={e => {
                      handleCloseImport(e);
                      setOpenImportRawHtml(!openImportRawHtml);
                    }}
                    disableRipple
                  >
                    <CodeIcon /> Raw HTML
                  </MenuItem>
                </ImportMenuWrapper>
              </Box>
              <Box>
                <Button disableElevation onClick={handleClickExport}>
                  Export
                </Button>
                <ImportMenuWrapper anchorEl={anchorElExport} open={openExport} onClose={handleCloseExport}>
                  <MenuItem
                    onClick={() => {
                      handleCloseExport();
                      exportRawHTML();
                    }}
                    disableRipple
                  >
                    <CodeIcon /> Raw HTML
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseExport();
                      exportMinimalHTML();
                    }}
                    disableRipple
                  >
                    <CodeIcon /> Minimal HTML
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseExport();
                      exportCustomHTML();
                    }}
                    disableRipple
                  >
                    <CodeIcon /> Custom HTML
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseExport();
                      exportFormattedText();
                    }}
                    disableRipple
                  >
                    <FormatTextdirectionLToRIcon /> Formatted Text
                  </MenuItem>
                </ImportMenuWrapper>
              </Box>
            </>
          )}
          <Box>
            <BackButton sx={{ "& button": { marginBottom: "0 !important" } }} />
          </Box>
          {content && content.trim() && (
            <>
              <Box>
                <Button
                  disableElevation
                  disabled={!connectedProjects.length || title === "" || metaDescription === ""}
                  onClick={() => {
                    setScheduleMode(false);
                    setOpenPublishDialog(true);
                  }}
                >
                  Publish
                </Button>
              </Box>
              <Box>
                <Button
                  disableElevation
                  disabled={!allProjects.length}
                  startIcon={<ScheduleIcon />}
                  onClick={() => {
                    setScheduleMode(true);
                    setOpenPublishDialog(true);
                  }}
                >
                  Schedule
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      <Dialog
        open={openPublishDialog}
        onClose={() => {
          setOpenPublishDialog(false);
          setScheduleMode(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" fontWeight={600}>
            {scheduleMode ? "Schedule Blog" : "Publish Blog"}
          </Typography>

          <Typography sx={{ mt: 1, mb: 2 }} color="text.secondary">
            {scheduleMode ? "Select a destination and pick a date/time" : "Select one destination to publish this blog"}
          </Typography>
          <FormControl fullWidth>
            {/* HEADER */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 60px 40px",
                px: 2,
                py: 1,
                mb: 1,
                fontWeight: 600,
                fontSize: "13px",
                color: "text.secondary",
              }}
            >
              <span>App Name</span>
              <span>App Type</span>
              <span>Status</span>
              <span>Select</span>
            </Box>

            {/* ROWS */}
            {(scheduleMode ? allProjects : connectedProjects).map(project => {
              const isConnected = project?.isConnected === true && project?.integrationToken && Object.keys(project.integrationToken).length > 0;
              return (
                <Box
                  key={project.id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr 60px 40px",
                    alignItems: "center",
                    px: 2,
                    py: 1.5,
                    mb: 1,
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: selectedProject?.id === project.id ? "primary.main" : "grey.300",
                    backgroundColor: selectedProject?.id === project.id ? "rgba(124, 58, 237, 0.08)" : "#fff",
                  }}
                >
                  <Typography fontWeight={600}>{project.appName || project.website}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {project.appType}
                  </Typography>
                  <Tooltip title={isConnected ? "Connected" : "Not connected"} arrow>
                    {isConnected ? <LinkIcon sx={{ fontSize: 18, color: "success.main" }} /> : <LinkOffIcon sx={{ fontSize: 18, color: "warning.main" }} />}
                  </Tooltip>
                  <input
                    type="checkbox"
                    checked={selectedProject?.id === project.id}
                    onChange={() => {
                      const isDeselecting = selectedProject?.id === project.id;
                      setSelectedProject(isDeselecting ? null : project);
                      setSelectedCategoryId("");
                      setCategories([]);
                      if (!isDeselecting && project.id) {
                        fetchCategories({ variables: { projectId: project.id } });
                      }
                    }}
                    style={{
                      width: 16,
                      height: 16,
                      accentColor: "#7c3aed",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              );
            })}
          </FormControl>

          {/* Category selector - shown when a WordPress project is selected */}
          {categoriesLoading && (
            <Box display="flex" alignItems="center" gap={1} sx={{ mt: 2 }}>
              <CircularProgress size={16} />
              <Typography variant="body2" color="text.secondary">
                Loading categories...
              </Typography>
            </Box>
          )}
          {categories.length > 0 && (
            <TextField
              select
              fullWidth
              size="small"
              label="Category"
              value={selectedCategoryId}
              onChange={e => setSelectedCategoryId(e.target.value)}
              helperText="Optional — defaults to Uncategorized"
              sx={{ mt: 2 }}
            >
              <MenuItem value="">
                <em>None (Uncategorized)</em>
              </MenuItem>
              {categories.map(cat => (
                <MenuItem key={cat.id} value={String(cat.id)}>
                  {cat.name}
                </MenuItem>
              ))}
            </TextField>
          )}

          {/* Featured Image */}
          {selectedProject && (
            <Box sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={useCustomImage}
                    onChange={e => {
                      setUseCustomImage(e.target.checked);
                      if (!e.target.checked) {
                        setFeaturedImageUrl("");
                        setImagePreview(null);
                        setRawImageSrc(null);
                      }
                    }}
                  />
                }
                label="Upload custom featured image"
              />
              <Typography variant="caption" color="text.secondary" display="block" sx={{ ml: 4.5, mt: -0.5 }}>
                {useCustomImage ? "Select an image and crop to 1400×840" : "The first image from blog content will be used automatically"}
              </Typography>
              {useCustomImage && (
                <Box sx={{ mt: 1 }}>
                  <Button variant="outlined" component="label" size="small" sx={{ textTransform: "none" }}>
                    {imagePreview ? "Change Image" : "Choose Image"}
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={async e => {
                        const file = e.target.files[0];
                        if (file) {
                          const base64 = await convertToBase64(file);
                          setRawImageSrc(base64);
                          setCropperOpen(true);
                        }
                        e.target.value = "";
                      }}
                    />
                  </Button>
                  {imagePreview && (
                    <Box sx={{ mt: 1, borderRadius: "8px", overflow: "hidden", maxHeight: 120 }}>
                      <img src={imagePreview} alt="Preview" style={{ width: "100%", maxHeight: 120, objectFit: "cover", borderRadius: "8px" }} />
                    </Box>
                  )}
                </Box>
              )}
              <ImageCropper
                open={cropperOpen}
                imageSrc={rawImageSrc}
                onClose={() => setCropperOpen(false)}
                onCropDone={croppedBase64 => {
                  setCroppedForEditor(croppedBase64);
                  setCropperOpen(false);
                  setEditorOpen(true);
                }}
              />
              <FeaturedImageEditor
                open={editorOpen}
                backgroundSrc={croppedForEditor}
                blogTitle={title}
                onClose={() => setEditorOpen(false)}
                onDone={finalBase64 => {
                  setFeaturedImageUrl(finalBase64);
                  setImagePreview(finalBase64);
                  setEditorOpen(false);
                }}
              />
            </Box>
          )}

          {/* Schedule date picker - shown when schedule mode is active */}
          {scheduleMode && (
            <Box sx={{ mt: 2 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label="Publish Date & Time"
                  value={scheduledAt}
                  onChange={val => setScheduledAt(val)}
                  disablePast
                  slotProps={{ textField: { fullWidth: true, size: "small", helperText: `Timezone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}` } }}
                />
              </LocalizationProvider>
              {scheduledAt && scheduledAt.isValid() && scheduledAt.isAfter(dayjs()) && (
                <Typography variant="body2" color="primary.main" sx={{ mt: 1 }}>
                  Will publish on {scheduledAt.format("ddd, MMM D, YYYY [at] h:mm A")}
                </Typography>
              )}
            </Box>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
            <Button
              variant="outlined"
              disabled={publishing || scheduling}
              onClick={() => {
                setSelectedProject(null);
                setOpenPublishDialog(false);
                setScheduleMode(false);
              }}
            >
              Cancel
            </Button>

            {scheduleMode ? (
              <Button variant="contained" disabled={!selectedProject || scheduling} onClick={() => handleScheduleBlog(selectedProject)}>
                {scheduling ? <CircularProgress size={20} color="inherit" /> : "Confirm Schedule"}
              </Button>
            ) : (
              <>
                <Button variant="outlined" startIcon={<ScheduleIcon />} disabled={!selectedProject || publishing} onClick={() => setScheduleMode(true)}>
                  Schedule
                </Button>
                <Button variant="contained" disabled={!selectedProject || publishing} onClick={() => handlePublishBlog(selectedProject)}>
                  {publishing ? <CircularProgress size={20} color="inherit" /> : "Publish"}
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Dialog>

      <Box className="FormWrapper" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* TITLE */}
        <Grid container alignItems="flex-end">
          <Grid item xs={content && content.trim() ? 11 : 12}>
            <FormControl className="BasicInput" fullWidth>
              <FormLabel>
                Title{" "}
                <Button size="small" onClick={generateTitleHandler}>
                  <AutoFixHighIcon />
                  {loadingTitle ? <CircularProgress size={15} sx={{ color: "#fff", ml: 1 }} /> : "Generate"}
                </Button>
              </FormLabel>

              <TextField variant="outlined" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} fullWidth />
            </FormControl>
          </Grid>
          {content && content.trim() && (
            <Grid textAlign="right" item xs={1}>
              <Tooltip title="Mark as Done" placement="top" arrow>
                <span>
                  <Button className="SaveBtn" sx={{ alignSelf: "flex-end" }} onClick={() => setOpenConfirm(true)}>
                    Done
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>

        {/* META DESCRIPTION */}
        <Grid container alignItems="flex-end">
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <FormControl
                className="BasicInput"
                fullWidth
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <FormLabel sx={{ mb: 1 }}>
                  Meta Description{" "}
                  <Button size="small" onClick={generateMetaDescriptionHandler}>
                    <AutoFixHighIcon />
                    {loadingMeta ? <CircularProgress size={15} sx={{ color: "#fff", ml: 1 }} /> : "Generate"}
                  </Button>
                </FormLabel>

                <CustomBgTextField
                  variant="outlined"
                  placeholder="Write or generate a meta description (200–250 characters)"
                  value={metaDescription}
                  onChange={e => setMetaDescription(e.target.value)}
                  multiline
                  rows={3}
                  inputProps={{ maxLength: 250 }}
                  helperText={`${metaDescription.length}/250 characters`}
                  fullWidth
                />
              </FormControl>
              {!(content && content.trim()) && (
                <Button onClick={() => setOpen(true)} variant="contained" startIcon={<AutoFixHighIcon />} sx={{ mt: 2 }}>
                  Content Builder
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>

        {/* DONE BUTTON */}
        {/* <Tooltip title="Mark as Done" placement="top" arrow>
          <span>
            <Button className="SaveBtn" sx={{ alignSelf: "flex-end" }} onClick={() => setOpenConfirm(true)}>
              Done
            </Button>
          </span>
        </Tooltip> */}

        {/* CONFIRM DIALOG */}
        <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
          <Box sx={{ p: 3, textAlign: "center" }}>
            <Typography variant="h6" fontWeight={600}>
              Important
            </Typography>

            <Typography sx={{ mt: 1 }}>Are you sure you want to save?</Typography>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
              <Button variant="contained" color="primary" onClick={handleConfirmSave} disabled={loading}>
                {loading ? <CircularProgress size={20} color="inherit" /> : "Save"}
              </Button>

              <Button variant="outlined" onClick={() => setOpenConfirm(false)}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      {/* <ContentGeneratePopup queryId={queryId} open={open} handleClose={handleClose} contentQuery={contentQuery} refetchContent={refetchContent} generateTitleHandler={generateTitleHandler} /> */}
      <ContentGeneratePopup
        queryId={queryId}
        open={open}
        handleClose={handleClose}
        contentQuery={contentQuery}
        refetchContent={refetchContent}
        initialTitle={title}
        setIsDirty={setIsDirty}
        metaDescription={metaDescription}
      />
      <ImportRawHtmlPopup
        open={openImportRawHtml}
        handleClose={handleCloseImportRawHtml}
        onImport={html => {
          if (!html.trim()) return;
          setContent(html);
          setIsDirty(true);
          handleCloseImportRawHtml();
        }}
      />
    </ContentEditHeaderStyle>
  );
}

export default ContentEditHeader;
